export const convertFromBinary = (array: number[]): string => {
  return new TextDecoder().decode(new Uint8Array(array));
};
